<template>
  <div class="title_box">
    <h1 class="text">{{ text }}</h1>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: ["text"],
  data() {
    return {
      data: []
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.title_box {
  height: 77px;
  background: url("~@/assets/common/title_bg.png") no-repeat center bottom;
  .text {
    font-size: 28px;
    font-weight: 800;
    color: #323232;
    text-align: center;
  }
}
</style>
